export default class Item {
    constructor() {
        this.id = "";
        this.name = "";
        this.category = "";
        this.subcategory = "";
        this.photoURL = "";
        this.quantity = 0;
        this.price = undefined;
        this.priceIngredients = 0;
        this.ingredients = [];
        this.details = "";
        this.localizedName = '';
        this.type = '';
    }
}
